import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "calendar-nav d-flex" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-arrow-down icon-rotate-90",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_4 = { class: "visually-hidden" }
const _hoisted_5 = { class: "calendar-nav__month" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-arrow-down icon-rotate-270",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_8 = { class: "visually-hidden" }
const _hoisted_9 = { class: "calendar-body" }
const _hoisted_10 = { class: "calendar-weekdays" }
const _hoisted_11 = { class: "calendar-weekday" }
const _hoisted_12 = { class: "calendar-dates" }
const _hoisted_13 = { class: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CalendarDate = _resolveComponent("CalendarDate")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["calendar-grid", _ctx.isLoading ? 'calendar-grid--is-loading' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "calendar-nav__button calendar-nav__button--prev",
        disabled: _ctx.checkIfPrevDisabled(),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.prevShownCalendar()))
      }, [
        _hoisted_3,
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.translate('shop.ticket.configuration.prev-button')), 1)
      ], 8, _hoisted_2),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.getMonthName(_ctx.dateConfig.month)) + " " + _toDisplayString(_ctx.dateConfig.year), 1),
      _createElementVNode("button", {
        class: "calendar-nav__button calendar-nav__button--next",
        disabled: _ctx.checkIfNextDisabled(),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.nextShownCalendar()))
      }, [
        _hoisted_7,
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.translate('shop.ticket.configuration.prev-button')), 1)
      ], 8, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekdays, (weekday) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("span", null, _toDisplayString(weekday), 1)
          ]))
        }), 256))
      ]),
      _createElementVNode("div", _hoisted_12, [
        (_ctx.dateConfig?.dates && _ctx.dateConfig.dates.length > 0)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.prevDayCount(_ctx.dateConfig?.dates[0].date), (i) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_13))
            }), 256))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateConfig.dates, (day) => {
          return (_openBlock(), _createBlock(_component_CalendarDate, {
            day: day,
            key: day.date,
            "start-date": _ctx.selectedDateStart,
            "is-selected-start-day": _ctx.selectedDateStart === day.date,
            "is-selected-end-day": _ctx.selectedDateEnd === day.date,
            "is-disabled": _ctx.checkIfDisabled(day),
            "is-in-range": !_ctx.isUndefined(_ctx.selectedDateStart) && !_ctx.isUndefined(_ctx.selectedDateEnd) && day.date > _ctx.selectedDateStart && day.date < _ctx.selectedDateEnd,
            "ticket-id": _ctx.ticketId,
            defaultPriceGroupId: _ctx.defaultPriceGroupId,
            onSelectDate: _cache[2] || (_cache[2] = (date) => _ctx.onSelectDate(date))
          }, null, 8, ["day", "start-date", "is-selected-start-day", "is-selected-end-day", "is-disabled", "is-in-range", "ticket-id", "defaultPriceGroupId"]))
        }), 128))
      ])
    ])
  ], 2))
}